export default ({ app }, inject) => {
  inject('jwt', () => {
    const token = app.$cookies.get('jwt_token')

    return token ? `Bearer ${token}` : null
  })
}
